import { Store } from 'src/store';

const getAppStartTime = (store: Store) => store.app.appStartTime;

export default getAppStartTime;
